import React, { useEffect, useState } from "react";
import "./PackageAdmin.css";

const PackageAdmin = () => {
  const [plans, setPlans] = useState([]);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    fetch("http://priyanthabandara.lk/getPricePlans.php")
      .then((res) => res.json())
      .then((data) => setPlans(data))
      .catch((err) => console.error("Failed to load plans", err));
  }, []);

  const handleFeatureChange = (planIndex, featureIndex, value) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].features[featureIndex] = value;
    setPlans(updatedPlans);
  };

  const addFeature = (planIndex) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].features.push("");
    setPlans(updatedPlans);
  };

  const removeFeature = (planIndex, featureIndex) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].features.splice(featureIndex, 1);
    setPlans(updatedPlans);
  };

  const saveToServer = () => {
    setSaving(true);
    fetch("http://priyanthabandara.lk/updatePricePlans.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(plans),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.success) {
          alert("Pricing plans updated successfully!");
        } else {
          alert("Failed to update pricing plans.");
          console.error(response.error);
        }
      })
      .catch((err) => {
        console.error("Server error:", err);
        alert("Error connecting to server.");
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="package-admin-container">
      <div className="admin-header">
        <h1>Package Features Management</h1>
        <p className="admin-subtitle">Edit and manage features for your pricing plans</p>
      </div>

      <div className="plan-tabs-container">
        <div className="plan-tabs">
          {plans.map((plan, index) => (
            <button
              key={index}
              className={`plan-tab ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              {plan.title}
            </button>
          ))}
        </div>
      </div>

      <div className="plan-editor-container">
        {plans.length > 0 && (
          <div className="plan-editor">
            <div className="plan-header">
              <h2>{plans[activeTab].title}</h2>
              <span className="feature-count">{plans[activeTab].features.length} features</span>
            </div>
            
            <div className="features-list">
              {plans[activeTab].features.map((feature, featureIndex) => (
                <div key={featureIndex} className="feature-item">
                  <input
                    type="text"
                    value={feature}
                    className="feature-input"
                    onChange={(e) =>
                      handleFeatureChange(activeTab, featureIndex, e.target.value)
                    }
                    placeholder="Enter feature description"
                  />
                  <button 
                    className="remove-feature-btn"
                    onClick={() => removeFeature(activeTab, featureIndex)}
                    title="Remove feature"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              ))}
            </div>

            <button 
              className="add-feature-btn"
              onClick={() => addFeature(activeTab)}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              Add New Feature
            </button>
          </div>
        )}
      </div>

      <div className="action-bar">
        <button 
          className="primary-btn save-btn" 
          onClick={saveToServer} 
          disabled={saving}
        >
          {saving ? (
            <>
              <svg className="spinner" width="18" height="18" viewBox="0 0 24 24">
                <path fill="currentColor" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/>
                <path fill="currentColor" d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z">
                  <animateTransform attributeName="transform" type="rotate" dur="0.75s" values="0 12 12;360 12 12" repeatCount="indefinite"/>
                </path>
              </svg>
              Saving...
            </>
          ) : (
            <>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Save Changes
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default PackageAdmin;